document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.mobile-swiper-container', {
    loop: true,
    autoplay: { delay: 3000 },
    slidesPerView: 4, // Default er desktop først
    spaceBetween: 30,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      // Ved 0px og opad (mobil først)
      0: {
        slidesPerView: 1,
      },
      // Fra 768px (tablets) vises 2 kolonner
      768: {
        slidesPerView: 2,
      },
      // Fra 992px og opad (desktops) vises 4 kolonner
      992: {
        slidesPerView: 4,
      },
    },
  });
  console.log('Swiper initialized via window.onload with breakpoints');
});